import React from 'react'
import cl from "./FitRow.module.css"

const FitRow = ({children}) => {
  return (
    <div className={cl.container}>
        {children}
    </div>
  )
}

export default FitRow